interface IAuthentication {
  sessionId: string;
  rememberMeSessionId: string;
  requiresTandCAcceptance: boolean;
  mustResetPassword: boolean;
  userId: number;
  isAuthenticated: boolean;
}

// Eventually there will be functions for Admin authentication and logging in as a user
// We don't have a use for those at the moment and I don't think the functions are solid yet
export default class AuthenticationService {
  baseUrl = '/aptitude/noauth/api/authentication/';

  constructor(private $http) {
    'ngInject';
  }

  /**
   *
   * @param  {string}                       userName
   * @param  {string}                       password
   * @param  {boolean}                      rememberMe Indicates whether the user wants his/her login to be preserved for whatever period we designate for "remembering" a user
   * @return {ng.IPromise<IAuthentication>}            Returns success or failure and indicators of whether the user needs to accept terms and conditions
   */
  authenticate(
    userName: string,
    password: string,
    rememberMe: boolean
  ): ng.IPromise<IAuthentication> {
    return this.$http.post(this.baseUrl, {
      userName,
      password,
      rememberMe
    });
  }

  isAuthenticated(): ng.IPromise<IAuthentication> {
    return this.$http.get(this.baseUrl);
  }
}
